import React from 'react'
import { Link } from 'react-router'

function Reminder() {
    return (
        <div>
            {/* HEADER */}
            {/* <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
                <div className="title_member">
                    <h4>Add Reminder</h4>
                    <nav className="page-breadcrumb">
                        <Link to="/">Home</Link>
                        <span className="mx-2">/</span>
                        <span>Add Reminder</span>
                    </nav>
                </div>

                <div className="page-title fw-semibold fs-18 mb-0">
                    <Link to="/reminder-list" className="add-btn">
                        Reminder List
                    </Link>
                </div>
            </div> */}

            {/* <div className="main_page">
                <div className="card"> */}
                    <div className="card-body">
                        <form>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label>
                                            Reminder Title <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control custumform"
                                            placeholder="Enter Reminder Title"
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Reminder Type</label>
                                        <select className="form-control custumform">
                                            <option>Task</option>
                                            <option>Meeting</option>
                                            <option>Call</option>
                                            <option>Birthday</option>
                                            <option>Personal</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>
                                            Reminder Date <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control custumform"
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label>
                                            Reminder Time <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="time"
                                            className="form-control custumform"
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label>Priority</label>
                                        <select className="form-control custumform">
                                            <option>Low</option>
                                            <option>Medium</option>
                                            <option>High</option>
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label>Repeat</label>
                                        <select className="form-control custumform">
                                            <option>None</option>
                                            <option>Daily</option>
                                            <option>Weekly</option>
                                            <option>Monthly</option>
                                            <option>Yearly</option>
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label>Status</label>
                                        <select className="form-control custumform">
                                            <option>Pending</option>
                                            <option>Completed</option>
                                        </select>
                                    </div>

                                    {/* <div className="col-md-6 mb-3">
                                        <label>Assign User</label>
                                        <select className="form-control custumform">
                                            <option>Select User</option>
                                            <option>Admin</option>
                                            <option>Rohit</option>
                                            <option>Deepak</option>
                                        </select>
                                    </div> */}

                                    {/* Description */}
                                    <div className="col-md-12 mb-3">
                                        <label>Description</label>
                                        <textarea
                                            className="form-control custumform"
                                            rows="4"
                                            placeholder="Enter Reminder Description"
                                        ></textarea>
                                    </div>

                                    {/* Submit */}
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-end">
                                            <div className="button_submit">
                                                <button
                                                    type="submit"
                                                    className="total_btn"
                                                >
                                                    Save Reminder
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                {/* </div>
            </div> */}
        </div>
    )
}

export default Reminder
